'use strict';

angular.module('ringbaPortal.services').factory('streamlinedZipcodeTagsService', streamlinedZipcodeTagsService);

function streamlinedZipcodeTagsService(
  _,
  tagService
) {
  'ngInject';

  const defaultBulkTagUploadSettings = 'AreaCodeAndZipCode';
  const defaultZipcodeKey = 'zipcode';
  const defaultAreaCodeType = 'InboundNumber';

  const service = {
    getExpandedZipcodeTags: getExpandedZipcodeTags,
    expandToZipcodeTags: expandToZipcodeTags,
    normalizeFromZipcodeTags: normalizeFromZipcodeTags,
    isZipcodeTypeTag: isZipcodeTypeTag,
    getPreSelectedTags: getPreSelectedTags,
    defaultBulkTagUploadSettings: defaultBulkTagUploadSettings,
    defaultZipcodeKey: defaultZipcodeKey
  };
  return service;

  function getPreSelectedTags(availableTags) {
    const tags = tagService.filterByTagSource(availableTags, defaultZipcodeKey);
    _.remove(tags, { tagType: defaultAreaCodeType });
    return tags;
  }

  function isZipcodeTypeTag(tags) {
    const tagSources = tagService.getTagSources(getExpandedZipcodeTags(tags));
    return (tagSources && tagSources.length == 1 && _.head(tagSources).id == 'zipcode');
  }

  function getExpandedZipcodeTags(tags) {
    const managedTags = [];
    expandToZipcodeTags(tags, managedTags);
    if (managedTags) {
      return _.map(managedTags, 'to');
    }

    return [];
  }

  function expandToZipcodeTags(tags, managedTagsFromTo) {
    if (tags) {
      tags = angular.copy(tags);
      tagService.filterByTagNames(tags, ['zipcode', 'Zip 5', 'AreaCode']).forEach(function (tag) {
        const tagTo = angular.copy(tag);
        
        tagTo.tagName = tagTo.tagSource;
        tagTo.tagSource = 'zipcode';

        tagService.pushDedupTag(tags, tagTo);

        if (managedTagsFromTo) {
          managedTagsFromTo.push({
            from: tag,
            to: tagTo
          });
        }
      });
    }

    return tags;
  }

  function normalizeFromZipcodeTags(tags, managedTagsFromTo) {
    const normalizedTags = [];

    _.forEach(tags, function (t) {
      normalizedTags.push(_normalizeFromZipcodeTag(t, managedTagsFromTo));
    });

    return normalizedTags;
  }

  function _normalizeFromZipcodeTag(tag, managedTagsFromTo) {
    if (managedTagsFromTo) {
      const managedTag = _.find(managedTagsFromTo, function (managedTag) {
        return tagService.areEqualTags(managedTag.to, tag);
      });

      if (managedTag) {
        return managedTag.from;
      }
    }

    return tag;
  }
}
